import { LitElement, html, css } from 'lit';

class GuestBook extends LitElement {
  static get styles() {
    return css`
      :host {
        display: block;
      }

      .description {
        font-weight: 500;
        padding-right: 0.3em;
      }

      .shadow {
        box-shadow: 0 4px 2px -2px gray;
        border-radius: 0 0 2px 2px;
      }

      #list {
        padding: 0.5em;
        background-color: #fff3e0;
      }

      @media screen and (min-width: 948px) {
        dl {
          -webkit-column-count: 2;
          -moz-column-count: 2;
          -ms-column-count: 2;
          -o-column-count: 2;
          column-count: 2;
        }
      }

      dt {
        color: #757575;
        font-size: 90%;
      }
      .all {
        padding-bottom: 0.5em;
      }

      dd {
        color: #455a64;
        margin: 0;
      }

      dt,
      dd,
      .all {
        break-inside: avoid;
        page-break-inside: avoid;
        -webkit-column-break-inside: avoid;
      }
      dt > span {
        font-weight: 600;
      }
      .title {
        background-color: #ff8f00;
        padding: 1em 0.5em;
        color: #fff;
        font-weight: 600;
      }
    `;
  }

  render() {
    return html`
      <div class="shadow">
        <div class="title">
          Gastenboek
        </div>
        <div id="list">
          ${this.comments.length > 0
            ? html`
                <dl>
                  ${this.comments.map(comment => {
                    return html`
                      <div class="all">
                        <dt>
                          <span>${this._title(comment.title)}. ${comment.surname}:</span>
                          ${comment.text}
                        </dt>
                      </div>
                    `;
                  })}
                </dl>
              `
            : `Er zijn nog geen reacties achtergelaten in dit gastenboek`}
        </div>
      </div>
    `;
  }

  constructor() {
    super();
    this.comments = [];
  }

  static get properties() {
    return {
      comments: {
        type: Array,
      },
    };
  }

  

  // eslint-disable-next-line class-methods-use-this
  _title(title) {
    return title === 'Mr' ? 'Dhr' : 'Mevr';
  }

  static get is() {
    return 'guest-book';
  }
}
customElements.define(GuestBook.is, GuestBook);
